var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgExchange = function SvgExchange(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 7A7 7 0 1 1 0 7a7 7 0 0 1 14 0ZM2.415 6.17l.837-2.977c.083-.296.46-.39.68-.18l.633.604a.229.229 0 0 0 .265.03c2.086-1.133 4.763-.911 6.617.67a.38.38 0 0 1 .01.567l-.44.42a.435.435 0 0 1-.574.011C9.193 4.28 7.457 4.053 5.995 4.64c-.12.048-.149.198-.049.293l.273.26a.395.395 0 0 1-.182.67l-3.125.797c-.297.076-.582-.188-.497-.49Zm8.333 4.637.837-2.976c.085-.303-.2-.567-.498-.49l-3.124.797a.395.395 0 0 0-.182.67l.273.26c.1.094.07.244-.049.292-1.462.587-3.198.361-4.448-.675a.435.435 0 0 0-.574.012l-.44.42a.38.38 0 0 0 .01.567c1.854 1.58 4.531 1.803 6.617.67a.229.229 0 0 1 .265.029l.633.603c.22.21.597.117.68-.18Z",
    fill: "#F5A623"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExchange);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Exchange.a267e3dd296f4a63e97327801470c43f.svg";